import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const startNoteSchema = new schema.Entity('startNoteContainer', {
    transferEvals: [schemas.transferEvals],
    prepopulateEvals: [schemas.prepopulateEvals]
});
